import React, { useEffect, useState } from 'react'
import ActionBar from '../actionBar'
import { fetchDistrictsForHead, fetchStatesForHead, getAllDistrictsForState, getAllStates } from '../../backend/backendApis'
import HttpService from '../../backend/requestApis'
import { genderList } from '../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedDistricts, setSelectedGender } from '../LandingPage/LandingPageSlice'

const DashboardsTopDropDowns = (props) => {

  const dispatch = useDispatch()
  const [selGender, setSelGender] = useState(['Male', 'Female'])
  const [states, setStates] = useState([])
  const [selectedState, setSelectedState] = useState([])
  const [districts, setDistricts] = useState([])
  const [selectedDistrict, setSelectedDistrict] = useState([])
  
  const updateSelectedGender = (value) => {
      setSelGender(value)
  }

  const updateSelectedStates = (value) => {
    setSelectedState(() => value)
  }

  const updateSelectedDistricts = (value) => {
    setSelectedDistrict(() => value)
  }

  useEffect(() => {
    let options = {
      url: fetchStatesForHead,
      method: 'GET',
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
      }
    }
    HttpService(options).then(response => {
      let states = response?.data?.data
      setStates(states)
      setSelectedState(states.map((s) => s.name))
    })

  }, [])

  useEffect(() => {
    let options = {
      url: fetchDistrictsForHead,
      method: 'GET',
      params:{
        stateFilter: selectedState
      },
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
      }
    }
    HttpService(options).then(response => {
      let districts = response?.data?.data
      setDistricts(districts)
      setSelectedDistrict(districts.map((d) => d.name))

    })
  }, [selectedState])

  useEffect(() => {
    let array = selectedDistrict
    dispatch(setSelectedDistricts(array))
  }, [selectedDistrict])

  useEffect(() => {
    dispatch(setSelectedGender(selGender))
  }, [selGender])

  
  return (
    <>
      <ActionBar dashBoard='chapterManangement'
          isTopDropDown = {true}
          gender={true}
					genderValue = {selGender}
					genderSetFunc = {updateSelectedGender}
          states = {true}
          statesList = {states}
          stateValue = {selectedState}
          stateSetFunc={updateSelectedStates}
          districts = {true}
          districtsList = {districts}
          districtValue = {selectedDistrict}
          districtSetFunc = {updateSelectedDistricts}
          templateDialogStatus = {props.templateDialogStatus}
          updateTemplateDialogStatus = {props.updateTemplateDialogStatus}
          filterMenu = {props.filterMenu}
      >
      </ActionBar>
      
    </>
  )
}

export default DashboardsTopDropDowns
